export default __webpack_public_path__ + "static/media/search.93837989.svg";